import { render, staticRenderFns } from "./IncidentsReports.vue?vue&type=template&id=41c6db87"
import script from "./IncidentsReports.vue?vue&type=script&lang=js"
export * from "./IncidentsReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports